import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { ConsumerReviewsModular } from 'site-modules/shared/components/consumer-reviews-modular/consumer-reviews-modular';

const SCROLL_OFFSET = -70;
const MIN_HEIGHT_MOBILE = '480px';
const MIN_HEIGHT_DESKTOP = '350px';

function ConsumerReviewVdpUI({
  vehicle = null,
  isMobile = false,
  isBasicViewEnabled = false,
  dataTrackingParent = 'consumer-reviews',
  header = undefined,
  isPrivatePartyListing = false,
}) {
  return (
    <VdpModule
      className={classnames({ 'mb-1_5': !isBasicViewEnabled })}
      contentCollapseClasses="mb-2_5"
      withIndents={false}
      collapseConfig={
        isBasicViewEnabled
          ? {
              minHeight: isMobile ? MIN_HEIGHT_MOBILE : MIN_HEIGHT_DESKTOP,
              scrollOffset: SCROLL_OFFSET,
              btnTrackingId: 'view_more_info',
            }
          : null
      }
    >
      <ConsumerReviewsModular
        vehicle={vehicle}
        creativeId={dataTrackingParent}
        isBasicViewEnabled={isBasicViewEnabled}
        header={header}
        isPrivatePartyListing={isPrivatePartyListing}
        actionButtonsEnabled
        showResearchLink
        openLinksInNewTab
        hideFeaturedReviews
      />
    </VdpModule>
  );
}

ConsumerReviewVdpUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
  isMobile: PropTypes.bool,
  dataTrackingParent: PropTypes.string,
  isBasicViewEnabled: PropTypes.bool,
  header: PropTypes.string,
  isPrivatePartyListing: PropTypes.bool,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const ConsumerReviewVdp = connect(mapStateToProps)(ConsumerReviewVdpUI);

ConsumerReviewVdp.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear,
};
